
import { Tab, Tabs, withStyles } from "@material-ui/core";

const StyledTabs = withStyles({
  root: {
    fontWeight: 500,
    color: "#1d262c",
  },
  indicator: {
    backgroundColor: "#6563ff",
    height: "4px",
    width: "110px",
    left: "35px"
  },
})(Tabs);

export const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#1d262c",
    fontSize: "16px",
    fontWeight: 500,
    margin: "0 10px",
    minWidth: "6px"
  },
}))((props: StyledTabProps) => <Tab disableRipple {...props} />);

export interface StyledTabProps {
  label: string;
}

export default StyledTabs;
